import { BreadcrumbItem, Breadcrumbs } from '@nextui-org/react'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const BreadCrumbs = ({data}) => {

    const navigate = useNavigate()

  return (
    <div className='mb-5'>
        <Breadcrumbs>
            {
                data.map((item, index) => {
                    return (
                        <BreadcrumbItem key={index} onPress={()=>navigate(item?.url)} isCurrent={index === data.length - 1} isLast={index === data.length - 1}>{item?.name}</BreadcrumbItem>
                    )
                })
            }
        </Breadcrumbs>
    </div>
  )
}

export default BreadCrumbs
